import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sponsor-requests',
  templateUrl: './sponsor-requests.component.html',
  styleUrls: ['./sponsor-requests.component.scss']
})
export class SponsorRequestsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
